<script>
export let datum
export let ringCount = 16
export let baseColour = [199, 64, 34]
export let max

let scaleFactor = 180
$: ringStrokeWidth = scaleFactor/ringCount - (scaleFactor/ringCount*0.2)

$: acceleration = Math.abs(datum.zAcc) / max * scaleFactor
$: noiseFloor = datum.noiseFloor / max * scaleFactor
$: threshold = datum.threshold / max * scaleFactor

$: ringsVisible = Math.floor(Math.abs(datum.zAcc) / max * ringCount) - 1

let rings = new Array(ringCount)

const vec2RGBA = function(vec3Colour, opacity){
  const rgbaString = `rgb(${vec3Colour[0]},${vec3Colour[1]},${vec3Colour[2]}, ${opacity})`
  return rgbaString
}

let colour = vec2RGBA(baseColour, 0.75)
let faintColour = vec2RGBA(baseColour, 0.2)

</script>

<svg id="radial_amplitude_visualizer" viewBox="-180 -180 360 360">
  <filter id="glow">
    <feDropShadow dx="0" dy="0" stdDeviation="2" flood-color="{colour}" flood-opacity="0.8" />
  </filter>
  
  <g filter="url(#glow)">
  {#each rings as ring, i}
    <circle class="ring" id="ring_{i}" 
      cx=0 cy=0 r={ (i+1) * scaleFactor / ringCount }
      fill="transparent" stroke="{ i <= ringsVisible ? colour : faintColour }" 
      style="stroke-width:{ringStrokeWidth}"
    />
  {/each}
  </g>
  
  <circle class="indicator" id="noise_floor" 
    cx=0 cy=0 r={noiseFloor} fill="transparent" stroke="purple"
  />

  <circle class="indicator" id="threshold" 
    cx=0 cy=0 r={threshold} fill="transparent" stroke="green"
  />

  <circle class="indicator" id="acceleration" 
    cx=0 cy=0 r={acceleration} fill="transparent" stroke="red"
  />

  
</svg>

<style>
  svg#radial_amplitude_visualizer {
    flex: 0 0 auto;
    width: 100vw;
  }
  /* svg circle.ring {
    stroke-width: 8;
  } */
  svg circle.indicator {
    stroke-width: 2;
  }
</style>